import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import LoyaltyCardDisplay from './LoyaltyCardDisplay';
import LoyaltyCardGenerator from './LoyaltyCardGenerator';
import LoyaltyTransactionHistory from './LoyaltyTransactionHistory';
import RedeemPointsModal from './RedeemPointsModal';
import EarnPointsModal from './EarnPointsModal';
import InlineLoader from '../Loader/InlineLoader';
import { API_BASE_URL } from '../../api';

export default function PatientLoyalty() {
    const { id: patientId } = useParams();
    const [card, setCard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [showRedeem, setShowRedeem] = useState(false);
    const [showEarn, setShowEarn] = useState(false);
    const [historyKey, setHistoryKey] = useState(0);

    const fetchCard = () => {
        setLoading(true);
        axios
            .get(`${API_BASE_URL}/api/v1/loyalty-cards/patient/${patientId}`, { withCredentials: true })
            .then(({ data }) => {
                setCard(data);
                setNotFound(false);
            })
            .catch((err) => {
                if (err.response?.status === 404) setNotFound(true);
                else console.error(err);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchCard(); }, [patientId]);

    const handleToggleStatus = async () => {
        const newStatus = card.status === 'ACTIVE' ? 'SUSPENDED' : 'ACTIVE';
        try {
            await axios.patch(
                `${API_BASE_URL}/api/v1/loyalty-cards/${card.id}/status`,
                { status: newStatus },
                { withCredentials: true }
            );
            toast.success(newStatus === 'ACTIVE' ? 'Carte réactivée' : 'Carte suspendue');
            fetchCard();
        } catch (err) {
            toast.error('Erreur lors de la mise à jour du statut');
        }
    };

    const handleTransactionSuccess = () => {
        fetchCard();
        setHistoryKey(k => k + 1);
    };

    if (loading) return <InlineLoader loadingMessage="Chargement de la carte..." />;

    if (notFound) return null;

    return (
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'flex-start' }}>
            {/* Left: card + actions */}
            <div style={{ flexShrink: 0, position: 'sticky', top: 0, alignSelf: 'flex-start' }}>
                <LoyaltyCardDisplay
                    card={card}
                    onEarn={() => setShowEarn(true)}
                    onRedeem={() => setShowRedeem(true)}
                    onToggleStatus={handleToggleStatus}
                />
            </div>

            {/* Right: transaction history */}
            <div style={{ flex: 1, minWidth: 300 }}>
                <div style={{
                    background: '#fff',
                    border: '1px solid #e8e8e8',
                    borderRadius: 12,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        background: '#f9fafb',
                        padding: '10px 20px',
                        borderBottom: '1px solid #e8e8e8',
                        fontSize: 11, fontWeight: 600,
                        letterSpacing: '0.06em',
                        textTransform: 'uppercase',
                        color: '#6b7280',
                    }}>
                        Historique des transactions
                    </div>
                    <LoyaltyTransactionHistory key={historyKey} cardId={card.id} />
                </div>
            </div>

            {/* Modals */}
            <EarnPointsModal
                show={showEarn}
                onClose={() => setShowEarn(false)}
                card={card}
                onSuccess={handleTransactionSuccess}
            />
            <RedeemPointsModal
                show={showRedeem}
                onClose={() => setShowRedeem(false)}
                card={card}
                onSuccess={handleTransactionSuccess}
            />
        </div>
    );
}
